import { ArrowLeftRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export default function SwapDialog({
  open, onOpenChange,
  selectedPlayerForSwap, generatedTeams, editedTeamOrders,
  targetTeamForSwap, setTargetTeamForSwap,
  targetPlayerForSwap, setTargetPlayerForSwap,
  executeSwap
}) {
  const getTeamPlayers = (team) => editedTeamOrders[team.team_number] || team.players || [];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="swap-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ArrowLeftRight className="h-5 w-5 text-orange-400" />
            Trocar Jogadores
          </DialogTitle>
          <DialogDescription>
            {selectedPlayerForSwap && (
              <span>
                Trocar <strong>{selectedPlayerForSwap.player?.name}</strong> (Time {selectedPlayerForSwap.teamNumber}) com outro jogador
              </span>
            )}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Selecione o Time de Destino</Label>
            <Select value={targetTeamForSwap || ""} onValueChange={setTargetTeamForSwap}>
              <SelectTrigger className="bg-input/50">
                <SelectValue placeholder="Escolha o time" />
              </SelectTrigger>
              <SelectContent>
                {generatedTeams?.filter(t => t.team_number !== selectedPlayerForSwap?.teamNumber).map(team => (
                  <SelectItem key={team.team_number} value={String(team.team_number)}>
                    Time {team.team_number} ({getTeamPlayers(team).length} jogadores)
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          {targetTeamForSwap && (
            <div className="space-y-2">
              <Label>Selecione o Jogador para Trocar</Label>
              <Select value={targetPlayerForSwap || ""} onValueChange={setTargetPlayerForSwap}>
                <SelectTrigger className="bg-input/50">
                  <SelectValue placeholder="Escolha o jogador" />
                </SelectTrigger>
                <SelectContent>
                  {(editedTeamOrders[parseInt(targetTeamForSwap)] ||
                    generatedTeams?.find(t => t.team_number === parseInt(targetTeamForSwap))?.players || [])
                    .map(player => (
                      <SelectItem key={player.id} value={player.id}>
                        {player.name} ({player.average})
                      </SelectItem>
                    ))}
                </SelectContent>
              </Select>
            </div>
          )}

          {selectedPlayerForSwap && targetPlayerForSwap && (
            <div className="p-3 rounded-lg bg-orange-500/10 border border-orange-500/30">
              <p className="text-sm text-center">
                <span className="font-semibold">{selectedPlayerForSwap.player?.name}</span>
                <span className="text-muted-foreground mx-2">&lrarr;</span>
                <span className="font-semibold">
                  {(() => {
                    const targetPlayers = editedTeamOrders[parseInt(targetTeamForSwap)] ||
                      generatedTeams?.find(t => t.team_number === parseInt(targetTeamForSwap))?.players || [];
                    return targetPlayers.find(p => p.id === targetPlayerForSwap)?.name || "Jogador";
                  })()}
                </span>
              </p>
            </div>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={executeSwap} disabled={!targetTeamForSwap || !targetPlayerForSwap}
            className="bg-orange-500 hover:bg-orange-600">
            <ArrowLeftRight className="h-4 w-4 mr-2" />
            Trocar Jogadores
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
